import useMobileSize from "features/shared/hooks/useMobileSize";
import React, { ReactElement, useEffect, useState } from "react";
import styled from "styled-components";
import AdminFAB from "../components/adminFAB";

import AdminNavbar from "../components/adminNavbar";

const withAdminNavbar: React.FC<ReactElement> = (wrappedComponent) => {
    const NavbarWrapper: React.FC = () => {
        const [isMobileSize] = useMobileSize();
        const [navbarShown, setNavbarShown] = useState(true);

        const handleFABClick = () => {
            setNavbarShown(true);
        };

        useEffect(() => {
            setNavbarShown(!isMobileSize);
        }, [isMobileSize]);

        return (
            <>
                <Container navbarShown={navbarShown}>
                    {navbarShown && <AdminNavbar />}
                    {wrappedComponent}
                </Container>
                <AdminFAB onClickHandler={handleFABClick} />
            </>
        );
    };
    return <NavbarWrapper />;
};

const Container = styled.div<{ navbarShown?: boolean }>`
    display: flex;
    height: 100%;

    // Overall ratio 1:8

    // The navbar
    & > div:first-child {
        flex: 0 0 16rem;
        box-shadow: 1px 0px 10px 1px rgba(231, 231, 231, 0.5);
    }

    // The rest of the page
    & > div:nth-child(2) {
        flex: 1;
        overflow: hidden;
    }

    // For mobile
    @media (max-width: 768px) {
        // Hide content so navbar extends fully if shown

        & > div {
            &:first-child {
                flex: 1;
            }

            &:nth-child(2) {
                display: ${(props) => (props.navbarShown ? "none" : "initial")};
            }
        }
    }
`;

export default withAdminNavbar;
